import { TableHeader, TableLoader } from '../commons'
import AuditSessionTableData from './AuditSessionTableData'
import { TableHeadersType } from '../../constant/tableHeadersConstants/tableHeadersType'
import { LoginResponseType } from '../../redux/auth/authTypes'
import { AuditSessionListType } from '../../redux/fixedAsset/fixedAssetRegisterTypes'
type AppProps = {
    fetching: boolean;
    tableHeaders: TableHeadersType[]|[];
    data: AuditSessionListType[]|[];
    history:any;
    loginData:LoginResponseType;

}
const AuditSessionTable = ({
    tableHeaders,
    fetching,
    data,
    history,
    loginData
}:AppProps) => {
  return <>{
    fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={4}
        /> :
    <div className='jobsType'>
    <table className="table thead-light table-bordered">
        <thead className='text-start sticky-table-header'>
            <TableHeader
                tableHeader={tableHeaders}

            />
        </thead>
        <tbody>
            <AuditSessionTableData
                tableHeaders={tableHeaders}
                data={data}
                history={history}
                loginData={loginData}

            />
           
        </tbody>
    </table>
</div>
  }
  </>
}

export default AuditSessionTable
